export const NETWORK_DEFAULT_MSG_FOR_OFFLINE = 'Network request failed';
export const NETWORK_OFFLINE_STATUS = 1000;
export const NETWORK_OFFLINE_CODE = 'OFFLINE';
